var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-monospace font-normal text-16 md:text-24 lg:text-32",class:{ 'text-gray-200': !_vm.isRunning }},[_vm._v("\n  "+_vm._s(_vm._f("timeElapsed")(_vm.secondsElapsed))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }